module.exports = "/assets/loading@2x.gif?quRiXQq";